import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Transaction } from '../../../api/transactions-api.service';
import { TransactionMonitorDialogComponent } from './transaction-monitor-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class TransactionMonitorDialogService {
  constructor(private readonly dialog: MatDialog) {}

  open(transaction: Transaction): void {
    this.dialog.open(TransactionMonitorDialogComponent, {
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh',
      maxHeight: '100vh',
      panelClass: 'transaction-monitor-dialog-panel',
      data: { transactionId: transaction.id },
    });
  }
}
